import type { CopyShape } from "../../intl";

import type { BRAND_LINKS_COPY_PT_BR } from "../links.copy";

export const BRAND_LINKS_COPY_ES_ES: CopyShape<typeof BRAND_LINKS_COPY_PT_BR> = {
  site: "Conoce Tãmi",
  signUp: "Crear mi cuenta",
  instagram: "Instagram",
  youtube: "YouTube",
  guide: "Guía completa de Tãmi",
};
